import {PricingContainer} from "../trip/pricing-container";


export function PriceTable() {
    return <PricingContainer/>;

}
